import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ProgressBar extends React.PureComponent {
  static propTypes = {
    max: PropTypes.number,
    value: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    progressClassName: PropTypes.string,
  }

  static defaultProps = {
    max: 100,
    value: 0,
    height: 20,
  }

  get percentComplete() {
    const { max, value } = this.props;
    if (value === 0) return 0;
    return parseInt((value / max) * 100);
  }

  get classNames() {
    const { className, height } = this.props;
    return classNames('progress-bar width-100pct', {
      [`border-radius-${this.borderRadius}`]: true,
      [`height-${height}`]: true,
      [className]: className,
    })
  }

  get progressClassNames() {
    const { height, progressClassName } = this.props;
    return classNames('progress', {
      [`width-${this.percentComplete}pct`]: true,
      [`border-radius-${this.borderRadius}`]: true,
      [`height-${height}`]: true,
      [progressClassName]: progressClassName,
    })
  }

  get borderRadius() {
    const { height } = this.props;
    return parseInt(height / 2);
  }

  render() {
    const { children } = this.props;

    return (
      <div className={this.classNames}>
        <div className={this.progressClassNames}>
          {children}
        </div>
      </div>
    )
  }
}